interface PackageBase {
  id: string;
  name: string;
  description?: string;
  modality: string;
  level: string;
  duration: string;
  modulesCount: number;
  totalModules: number;  // Backend field name
  discount: number;
  image: string;
  imageUrl: string;      // Backend field name
  price?: number;        // Backend field name
  isRecurring?: boolean;
  recurrenceIntervalMonths?: number | null;
}

export interface StudentProgress {
  progress: number;
  status: string;
  startDate?: string;
  endDate?: string;
  isCompleted?: boolean;
}

export interface PurchasedPackage extends PackageBase {
  studentProgress?: StudentProgress;
  /** Same “has access now” bit as the cashier. Do not infer from expiresAt. */
  isValidNow?: boolean;
}

export type AvailablePackage = PackageBase;

// Nova interface para representar informações de módulos dentro de um pacote
export type PackageModuleState =
  | "not_available"
  | "available"
  | "in-progress"
  | "completed"
  | "needs_purchase";

const ACTIVATABLE_MODULE_STATES: ReadonlySet<PackageModuleState> = new Set([
  "needs_purchase",
  "available",
  "in-progress",
  "completed",
]);

export function isActivatableModuleState(
  state: string | undefined | null,
): state is Exclude<PackageModuleState, "not_available"> {
  return state != null && ACTIVATABLE_MODULE_STATES.has(state as PackageModuleState);
}

export interface PackageModuleInfo {
  id: string;
  name: string;
  description: string;
  title?: string;
  teaser?: string;
  summarizedDescription?: string;
  order: number;
  state: PackageModuleState;
  purchasePackageId?: string;
}
 